// Matches backend business_date_today(): "today" is the Pacific calendar day,
// so a report run late at night agrees with the server's date arithmetic.
export function pacificTodayISO(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

// A relative_date window is directional. 'last' looks backward — n calendar days
// ending today: [today-(n-1), today]. 'next' looks forward — n calendar days
// starting today: [today, today+(n-1)]. Both are inclusive of today (Pacific) and
// use the same UTC-arithmetic pattern so the offset math never touches a local
// timezone.
export function resolveRelativeDateRange(
  days: number,
  direction: 'last' | 'next' = 'last'
): {
  start: string;
  end: string;
} {
  const today = pacificTodayISO();
  const [y, m, d] = today.split('-').map(Number);
  const shifted = new Date(Date.UTC(y, m - 1, d));
  if (direction === 'next') {
    shifted.setUTCDate(shifted.getUTCDate() + (days - 1));
    return { start: today, end: shifted.toISOString().slice(0, 10) };
  }
  shifted.setUTCDate(shifted.getUTCDate() - (days - 1));
  return { start: shifted.toISOString().slice(0, 10), end: today };
}
